import React from 'react';
import { Empty } from 'antd';
import { useParams } from 'react-router';
import { useProjectPhase } from '../hooks';
import { PhaseType } from '../types';
import { ProjectMapPage } from './ProjectMapPage';
import { ProjectProposalPage } from './ProjectProposalPage';
import { ProjectSitePlanPage } from './ProjectSitePlanPage';
import { Loader } from '../../../components/UI/Loader';

export const ProjectPhasePage: React.FC = () => {
  const { phaseId } = useParams();
  const { phase, loading } = useProjectPhase(phaseId);

  if (loading) {
    return <Loader />;
  }

  if (!phase) return null;

  switch (phase.type) {
    case PhaseType.MAP:
      return <ProjectMapPage phaseId={phase.id} />;
    case PhaseType.SITE_PLAN:
      return <ProjectSitePlanPage phaseId={phase.id} />;
    case PhaseType.PROPOSAL:
      return <ProjectProposalPage phaseId={phase.id} />;
    default:
      return <Empty description="Phase view is not implemented yet." />;
  }
};
